<template>
    <div v-if="pessoa" data-backdrop="static" class="modal show" id="ExclusaoPessoas" tabindex="-1" role="dialog" :aria-labelledby="'ExclusaoPessoasLabel'" aria-hidden="true">
        <div class="modal-dialog  modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="ExclusaoPessoasLabel">
                        <b-icon icon="exclamation-triangle-fill" class="text-danger mr-1" aria-hidden="true"></b-icon>
                        <slot name="titulo"></slot>
                    </h5>
                </div>
                <div class="modal-body">
                    <b-alert class="text-center font-weight-bold" v-if="pessoaExcluida.status=='OK'" variant="success" show>{{ pessoaExcluida.mensagem }}</b-alert>
                    <b-alert class="text-center font-weight-bold" v-if="pessoaExcluida.status=='NOK'" variant="danger" show>{{ pessoaExcluida.mensagem }}</b-alert>

                    <p v-if="!pessoaExcluida.status" class="ec-exclusao__aviso">
                        Você está prestes a excluir o usuário abaixo. Ele perde o acesso ao sistema, deixa de aparecer nas listagens e não pode ser recuperado por esta tela.
                    </p>

                    <dl class="ec-exclusao__ficha">
                        <dt>ID</dt>
                        <dd>{{ pessoa.id }}</dd>
                        <dt>Nome</dt>
                        <dd>{{ pessoa.nome || '—' }}</dd>
                        <dt>CPF</dt>
                        <dd>{{ pessoa.cpf || '—' }}</dd>
                    </dl>
                </div>
                <div class="modal-footer">
                    <button v-if="!pessoaExcluida.status" type="button" class="btn btn-danger" :id="'btnOkExclusaoPessoas'" @click="excluirPessoa(pessoa)"><b-icon icon="trash-fill" aria-hidden="true"></b-icon> Excluir</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" :id="'Fechar'" @click="fechar()">Fechar</button>
                </div>
            </div>
        </div>
        <loading id="DeleteUser" titulo="Excluindo, Aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
    </div>
</template>

<script>
export default {
    props:{
        urlRedirect:{type:String, requied:true},
        pessoa:{type:Object, requied:false},
        urlSistema:{type:String, requied:true},
        
    },
    
    data(){
        return {
            pessoaSelecionada:{},
            pessoaExcluida:{},
            exibirModal:true,
            excluido:false,
        }
    },
    created(){
         this.pessoaSelecionada = this.pessoa
    },
    methods:{
        redirect(){
            window.location.href = this.urlRedirect;
        },
        fechar(){
            this.pessoaExcluida = {}

            if(this.excluido==true){
                this.$emit('exclusaoconcluida' /*, this.nclick*/);
            }

        },
        excluirPessoa(pessoa){
            $('#DeleteUser').modal('show');
            var config = {
            method: 'delete',
            url: '/api/v1'+this.urlSistema+'/'+pessoa.id,
            // headers: {
            //         'Accept': 'application/json',
            //         'Authorization': this.$root.token(),
            //     },
            };
            //executa requisição
            axios(config)
            .then(response => {

                this.pessoaExcluida = response.data;
                this.excluido = true
                
                $('#DeleteUser').modal('hide');
                this.exibirModal = true;
                
            })
            .catch(error => {
                console.log(error);
                this.exibirModal = false;
                $('#DeleteUser').modal('hide');
                this.excluido = false
            });

            $("#ExclusaoPessoas").modal('');
        }
        
    }
}
</script>

<style scoped>
    /* resumo do registro a excluir: rótulo à esquerda, valor à direita (empilha no celular) */
    .ec-exclusao__aviso {
        margin-bottom: .85rem;
        color: #b42318;
        font-size: .875rem;
    }

    .ec-exclusao__ficha {
        display: grid;
        grid-template-columns: max-content 1fr;
        gap: .45rem 1rem;
        margin: 0;
        padding: .75rem 1rem;
        background: #f8fafb;
        border: 1px solid #e3e9ed;
        border-radius: .5rem;
        text-align: left;
    }

    .ec-exclusao__ficha dt {
        align-self: center;
        font-size: .68rem;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
        color: #64767c;
    }

    .ec-exclusao__ficha dd {
        margin: 0;
        font-weight: 600;
        overflow-wrap: anywhere;
        font-variant-numeric: tabular-nums;
    }

    @media (max-width: 575.98px) {
        .ec-exclusao__ficha { grid-template-columns: 1fr; gap: .1rem; }
        .ec-exclusao__ficha dd { margin-bottom: .5rem; }
        .ec-exclusao__ficha dd:last-child { margin-bottom: 0; }
    }
</style>
